import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { translate, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Menu, Image, Header, Responsive } from 'semantic-ui-react';
import SignInGraphic from 'img/signin-webapp-graphic.png';
import Logo from 'img/logo.png';

import Utils from 'utils/Utils.js';

import { colors, fontSizes } from 'style';
import { fonts } from '../../style';


var style = {
    content: {
        height: '100%',
        backgroundColor: '#CFECED',
    },
    children: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-45%)",
        right: "15rem",
        zIndex: 1,
        boxShadow: "rgba(34, 36, 38, 0.15) 3px 3px 5px 0px",
        maxWidth: "35rem"
    },
    childrenMobile: {
        zIndex: 1,
        boxShadow: "rgba(34, 36, 38, 0.15) 3px 3px 5px 0px",
        maxWidth: "26rem",
        margin: "auto"
    },
    childrenContainerMobile: {
        textAlign: "center",
        marginBottom: "3rem"
    },
    heroText: {
        position: "absolute",
        top: "40%",
        transform: "translateY(-50%)",
        left: "15rem",
        fontSize: "3rem"
    },
    heroTextMobile: {
        padding: "1.5rem"
    },
    banner: {
        fontSize: "2rem",
        lineHeight: '1.5em',
    },
    bannerItem: {
        fontSize: fontSizes.body,
        paddingRight: "15rem"
    },
    logoItem: {
        paddingLeft: "15rem"
    },
    header: {
        fontSize: fontSizes.h1,
        color: colors.themeDarkerGrey
    },
    headerMobile: {
        paddingTop: "7rem",
        fontSize: fontSizes.h4,
        color: colors.themeDarkerGrey,
        paddingLeft: "1rem",
        paddingRight: "1rem"        
    },
    body: {
        height: '100%',
    },
    backgroundGraphic: {
        position: "absolute",
        left: "15rem",
        bottom: "5rem",
        width: "60rem",
        zIndex: 0,
    },
    backgroundGraphicMobile: {
        // position: "absolute",
        // bottom: "2rem",       
        zIndex: 0
    },
    subHeader: {
        fontSize: fontSizes.h4,
        paddingTop: "1rem",
        color: colors.themeDarkerGrey
    },
    subHeaderMobile: {
        fontSize: fontSizes.bodyL,
        color: colors.themeDarkerGrey
    },
    valueList: {
        fontSize: fontSizes.bodyL,
        fontWeight: "bold",
        lineHeight: "3rem",
        color: colors.themeDarkerGrey
    },
    valueListMobile: {
        fontSize: fontSizes.body,
        fontWeight: "bold",
        lineHeight: "2rem",
        color: colors.themeDarkerGrey
    }
};

const subheaders = [
    'signup_subheader1',
    'signup_subheader2',
    'signup_subheader3',
    'signup_subheader4',
    'signup_subheader5',
    'signup_subheader6',
];

class ImageWrapper extends Component {
    constructor(props) {
        super(props)
    }

    renderItem() {
        if (this.props.history.location.pathname === '/login') {
            return (<Trans i18nKey="new_here">
                New here? <Link to='/register' style={style.anchor}>Sign Up</Link>
            </Trans>)
        } else if (this.props.history.location.pathname === '/register') {
            return (<Trans i18nKey="already_a_user">
                Already have an account? <Link to='/login' style={style.anchor}>Log In</Link>
            </Trans>)
        }
    }

    render() {
        return (
            <div style={style.content}>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <Menu style={style.banner} fixed="top" borderless size="massive">
                        <Menu.Item style={style.logoItem}>
                            <Image src={Logo} size="small" />
                        </Menu.Item>
                        <Menu.Item style={style.bannerItem} position="right">
                            {this.renderItem()}
                        </Menu.Item>
                    </Menu>
                    <div style={style.body}>
                        <div style={style.heroText}>
                            <Header as="h1" style={style.header}>
                                {this.props.t("live_healthier_feel_happier")}<br />{this.props.t("earn_rewards")}
                                <Header.Subheader style={style.subHeader}>
                                    <strong>{this.props.t("improve_your_health")}</strong>
                                </Header.Subheader>
                            </Header>
                            <ul style={style.valueList}>
                                <li>{this.props.t("quick_and_easy")}</li>
                                <li>{this.props.t("fun_challenges")}</li>
                                <li>{this.props.t("progress_tracking")}</li>
                                <li>{this.props.t("special_offers")}</li>
                            </ul>
                        </div>
                        <div style={style.children}>
                            {this.props.children}
                        </div>
                        <Image style={style.backgroundGraphic} src={SignInGraphic} />
                    </div>
                </Responsive>



                <Responsive {...Responsive.onlyMobile}>
                    <Menu style={style.banner} fixed="top" borderless size="massive">
                        <Menu.Item>
                            <Image src={Logo} size="small" />
                        </Menu.Item>                        
                    </Menu>
                    <div style={style.body}>
                        <div style={style.heroTextMobile}>
                            <Header as="h1" style={style.headerMobile}>
                                {this.props.t("live_healthier_feel_happier")}<br />{this.props.t("earn_rewards")}
                                <Header.Subheader style={style.subHeaderMobile}>
                                    <strong>{this.props.t("improve_your_health")}</strong>
                                </Header.Subheader>
                            </Header>
                            <ul style={style.valueListMobile}>
                                <li>{this.props.t("quick_and_easy")}</li>
                                <li>{this.props.t("fun_challenges")}</li>
                                <li>{this.props.t("progress_tracking")}</li>
                                <li>{this.props.t("special_offers")}</li>
                            </ul>
                        </div>
                        <Image style={style.backgroundGraphicMobile} src={SignInGraphic} />
                        <div style={style.childrenContainerMobile}>
                            <div style={style.childrenMobile}>
                                {this.props.children}
                            </div>
                        </div>                        
                    </div>
                </Responsive>
            </div>
        )
    }
}

export default withRouter(translate('authentication')(ImageWrapper));



// WEBPACK FOOTER //
// ./src/modules/authentication/ImageWrapper.js